export default {
  NAME: import.meta.env.VITE_COOKIE_NAME ? String(import.meta.env.VITE_COOKIE_NAME) : 'auth_token',
  DOMAIN: import.meta.env.VITE_COOKIE_DOMAIN ? String(import.meta.env.VITE_COOKIE_DOMAIN) : '',
  SECURE: import.meta.env.VITE_COOKIE_SECURE
    ? import.meta.env.VITE_COOKIE_SECURE === '1' ||
      import.meta.env.VITE_COOKIE_SECURE.toUpperCase() === 'TRUE'
    : false,
  DURATION: import.meta.env.VITE_COOKIE_DURATION
    ? parseInt(import.meta.env.VITE_COOKIE_DURATION, 10)
    : 7,
}
